import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  addComponentLoading: false,
  systemList: [],
  diagramList: [],
  iconList: [],
  filterList: [],
};

const canvasSlice = createSlice({
  name: 'canvas',
  initialState: INITIAL_STATE,
  reducers: {
    setLoadingForFetchAndAddComponent: (state, action) => {
      state.addComponentLoading = action.payload;
    },
    setSystemComponents: (state, action) => {
      state.systemList = action.payload;
    },
    setDiagramComponents: (state, action) => {
      state.diagramList = action.payload;
    },
    setIconsComponent: (state, action) => {
      state.iconList = action.payload;
    },
    setFilterList: (state, action) => {
      state.filterList = action.payload;
    },
  },
});
export default canvasSlice.reducer;
export const {
  setLoadingForFetchAndAddComponent,
  setSystemComponents,
  setDiagramComponents,
  setIconsComponent,
  setFilterList,
} = canvasSlice.actions;
export const canvasSelector = (state) => state.canvas;
